<template>
  <!-- pretraga samo dogadjaja (naziv, mesto, kategorija); iznad stranica kalendara dogadjaja -->
  <SiteSearch placement="inline"
              scope="dogadjaji"
              placeholder="Pretraži događaje…"
              noun="događaja"
              label="Pretraga događaja: traži samo u kalendaru događaja, po nazivu, mestu i kategoriji. Za pretragu celog sajta koristite polje na vrhu stranice."
              results-route="kalendar-dogadjaja-pretraga"
              results-path="/kalendar-dogadjaja-pretraga" />
</template>

<script setup>
import SiteSearch from '~/components/search/SiteSearch.vue'
</script>
